// 더미 데이터 관련 상수 및 함수들

// 닉네임과 배후성의 고정된 매핑
export const NICKNAME_BACKGROUND_MAP = {
  "한명오": "절름발이 사기꾼",
  "김남운": "심연의 흑염룡",
  "공필두": "디펜스 마스터",
  "이설화": "구암신의",
  "민지원": "매금지존",
  "안나 크로프트": "아스가르드",
  "아스카 렌": "이천일류의 달인",
  "이즈미 히로키": "여덞 머리의 군주",
  "미치오 쇼지": "뱀을 베는 자"
};

// 더미 닉네임 배열
export const DUMMY_NICKNAMES = Object.keys(NICKNAME_BACKGROUND_MAP);

// 더미 배후성 배열
export const DUMMY_BACKGROUNDS = Object.values(NICKNAME_BACKGROUND_MAP);

// 사용된 닉네임을 추적하는 Set
let usedNicknames = new Set<string>();

// 랜덤한 더미 닉네임 선택 (중복 방지)
export const getRandomDummyNickname = (): string => {
  // 사용 가능한 닉네임 필터링
  const availableNicknames = DUMMY_NICKNAMES.filter(nickname => !usedNicknames.has(nickname));
  
  // 모든 닉네임이 사용된 경우 Set 초기화
  if (availableNicknames.length === 0) {
    usedNicknames.clear();
    return DUMMY_NICKNAMES[Math.floor(Math.random() * DUMMY_NICKNAMES.length)];
  }
  
  // 사용 가능한 닉네임 중에서 랜덤 선택
  const randomIndex = Math.floor(Math.random() * availableNicknames.length);
  const selectedNickname = availableNicknames[randomIndex];
  
  // 선택된 닉네임을 사용된 목록에 추가
  usedNicknames.add(selectedNickname);
  
  return selectedNickname;
};

// 닉네임에 따른 배후성 선택
export const getBackgroundByNickname = (nickname: string): string => {
  return NICKNAME_BACKGROUND_MAP[nickname as keyof typeof NICKNAME_BACKGROUND_MAP] || "알 수 없는 배후성";
};

// 랜덤한 더미 배후성 선택
export const getRandomDummyBackground = (): string => {
  const randomIndex = Math.floor(Math.random() * DUMMY_BACKGROUNDS.length);
  return DUMMY_BACKGROUNDS[randomIndex];
};

// 랜덤한 나이 생성 (20-50세)
export const getRandomAge = (): number => {
  return Math.floor(Math.random() * 31) + 20; // 20-50
};

// 랜덤한 아바타 번호 생성 (00-99)
export const getRandomAvatarNumber = (): string => {
  const randomNumber = Math.floor(Math.random() * 100);
  return randomNumber.toString().padStart(2, '0');
};

// 더미 유저 데이터 생성
export const createDummyUserData = (nickname?: string) => {
  const selectedNickname = nickname || getRandomDummyNickname();
  
  // 특정 닉네임이 전달된 경우에도 사용된 목록에 추가
  if (nickname && !usedNicknames.has(nickname)) {
    usedNicknames.add(nickname);
  }
  
  return {
    nickname: selectedNickname,
    age: getRandomAge().toString(),
    background: getBackgroundByNickname(selectedNickname),
    avatarNumber: getRandomAvatarNumber(),
    coinCount: Math.floor(Math.random() * 1000) + 100, // 100-1099 코인
    zoneClearStatus: {
      zone1: '아직안품',
      zone2: '아직안품',
      zone3: '아직안품',
      zone4: '아직안품',
      zone5: '아직안품',
      zone6: '아직안품'
    },
    receivedMessages: [
      {
        isSystemMessage: true,
        message: "당신을 바라봅니다.",
        receivedAt: new Date(),
        senderNickname: getRandomDummyBackground()
      }
    ],
    sentMessages: []
  };
};

// 사용된 닉네임 목록 초기화 함수
export const resetUsedNicknames = (): void => {
  usedNicknames.clear();
};
